import { IdPackageType } from "./IdPackageType";
export var arrayInitialPackagesTypes = [
    IdPackageType.CoopLeague,
    IdPackageType.GrowingGold,
    IdPackageType.GrowingDollar,
    IdPackageType.GrowingResource,
    IdPackageType.PlayerLeague,
    IdPackageType.CollectLeague,
];



//////////////////
// WEBPACK FOOTER
// ./src/constants/arrayInitialPackagesTypes.ts
// module id = 1961
// module chunks = 3